import { render, staticRenderFns } from "./viewEmp.vue?vue&type=template&id=05b1aa5e"
import script from "./viewEmp.vue?vue&type=script&lang=js"
export * from "./viewEmp.vue?vue&type=script&lang=js"
import style0 from "./viewEmp.vue?vue&type=style&index=0&id=05b1aa5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports